<template>
    <div :class="from === 'me' ? 'bubble-grey' : 'bubble'">
        <span v-if="message.type === 'attachment'">
            <v-icon color="primary" size="17">mdi-download</v-icon>
            <a :href="message.file.downloadURL" target="_blank" :download="message.message" v-html="message.message"/>
        </span>
        <span v-else v-html="message.message"/>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: Object,
            default: null,
        },
        from: {
            type: String,
            default: 'me',
        }
    },
}
</script>

<style scoped>

.bubble {
    position: relative;
    background-color: var(--v-secondary-base);
    border-radius: 4px;
    padding: 5px 10px;
    font-size: 13px;
    color: #FFFFFF;
    display: inline-block;
    word-break: break-word;
    white-space: pre-line;
}

.bubble:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: -5px;
    border-bottom: 10px solid transparent;
    border-right: 10px solid var(--v-secondary-base);
}

.bubble-grey {
    position: relative;
    background-color: var(--v-backGroundPrimary-lighten5);
    border-radius: 4px;
    padding: 5px 10px;
    font-size: 13px;
    color: #FFFFFF;
    display: inline-block;
    word-break: break-word;
    white-space: pre-line;
}

.bubble-grey:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: -5px;
    border-bottom: 10px solid transparent;
    border-left: 10px solid var(--v-backGroundPrimary-lighten5);
}

a {
    color: var(--v-accent-base);
}

</style>